import React from 'react';
import classnames from 'classnames';
import { node, oneOf } from 'prop-types';

import styles from './Badge.css';

const Badge = ({ children, color, ...rest }) => (
  <div className={classnames(styles.badge, styles[color])} {...rest}>
    {children}
  </div>
);

Badge.propTypes = {
  children: node.isRequired,
  color: oneOf([
    'black',
    'blue',
    'red',
    'orange',
    'green',
    'purple'
  ])
};

Badge.defaultProps = {
  color: 'black'
};

Badge.displayName = 'Badge';

export default Badge;


// WEBPACK FOOTER //
// ./src/uis/elements/Badges/Badge.js